var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useFormik } from "formik";
import { useEffect, useMemo, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
// import { errorPageService } from "../../services/errorPageService"
import { errorService } from "../..";
import FTLObjectUtils from "../../util/object";
import useDebounce from "../util/useDebounce";
export default ({ pageType = "new", initialValues, validationSchema, omitValues = [], getDetails, onSubmit, handleFetchedEntity, enableReinitialize, }) => {
    var _a, _b, _c;
    const { id, propertyId } = useParams();
    const history = useHistory();
    const [entityData, setEntityData] = useState(((_a = history.location.state) === null || _a === void 0 ? void 0 : _a.data) ? history.location.state.data : initialValues);
    const [isFetching, setIsFetching] = useState(pageType === "edit" && !((_b = history.location.state) === null || _b === void 0 ? void 0 : _b.data));
    const debouncedIsFetching = useDebounce(isFetching, 100);
    const formik = useFormik({
        initialValues: ((_c = history.location.state) === null || _c === void 0 ? void 0 : _c.data)
            ? history.location.state.data
            : initialValues,
        validationSchema,
        enableReinitialize,
        onSubmit,
    });
    const isFormNotChanged = useMemo(() => {
        const values = Object.assign({}, formik.values);
        const entityDataValues = Object.assign({}, entityData);
        omitValues.forEach((key) => {
            //@ts-ignore
            delete values[key];
            //@ts-ignore
            delete entityDataValues[key];
        });
        return FTLObjectUtils.compare(values, entityDataValues);
    }, [formik.values, entityData]);
    useEffect(() => {
        var _a;
        if (pageType === "edit" && id && getDetails && handleFetchedEntity) {
            setIsFetching(!((_a = history.location.state) === null || _a === void 0 ? void 0 : _a.data));
            getDetails(id, propertyId)
                .then((response) => __awaiter(void 0, void 0, void 0, function* () {
                yield handleFetchedEntity(response);
            }))
                .catch((error) => {
                if (!String(error.config.baseURL).includes("https://mc.yandex.ru") ||
                    !String(error.config.baseURL).includes("https://mc.yandex.ru/") ||
                    !String(error.config.baseURL).includes("https://mc.yandex.ru/watch") ||
                    !String(error.config.baseURL).includes(" https://mc.yandex.ru/watch/")) {
                    setIsFetching(true);
                    errorService.show({
                        error,
                    });
                }
                // errorPageService.show({
                //   error,
                // })
            })
                .finally(() => {
                setIsFetching(false);
            });
        }
    }, [id, propertyId, pageType]);
    return {
        isFetching,
        /**
         * Отложенный isFetching на 100мс. Нужен, чтобы бэкдроп не мелькал, если данные загружаются за < 100мс.
         */
        debouncedIsFetching,
        /**
         * Объект формика.
         */
        formik,
        /**
         * Берется из роута.
         */
        id,
        /**
         * Берется из роута.
         */
        propertyId,
        history,
        /**
         * Данные формика для понимания того трогал ли пользователь какие-либо поля. По умолчанию равно initialValues.
         * В колбеке handleFetchedEntity нужно обязательно обновить entityData.
         */
        entityData,
        /**
         * True, если entityData структурно повторяет formik.values
         */
        isFormNotChanged,
        setEntityData,
        setIsFetching,
    };
};
//# sourceMappingURL=useDetailPage.js.map